import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { MaskedInput } from 'react-text-mask-modern';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { changePxTalkActions } from '../../../actions';
import { ButtonSwitch } from '../../controls';
import { pxTalkLevelTypes } from '../../../constants';
import { numericUtils } from '../../../utils';
import { PxTalk } from '../../../types/bwic/PxTalk';
import { useAppDispatch } from '../../../effects/useAppDispatch';
import { useAppSelector } from '../../../effects/useAppSelector';
import { LevelType } from '../../../types/bwic/LevelType';

const dmMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    allowDecimal: true,
    allowNegative: true,
    decimalLimit: null
});

interface PxTalkRowProps {
    pxTalk: PxTalk & { error?: string };
}

export function PxTalkRow({ pxTalk }: PxTalkRowProps) {
    const dispatch = useAppDispatch();
    const [changed, setChanged] = useState(true);

    const isRequestingEvalDm = useAppSelector(
        state => !!state.changePxTalk.evalDmRequestState[pxTalk.company.id]
    );

    const dmFromStore = numericUtils.isNumber(pxTalk.evalDmResponse?.dm) ? String(pxTalk.evalDmResponse!.dm) : '';
    const [dmValue, setDmValue] = useState(dmFromStore);

    useEffect(() => {
        setDmValue(dmFromStore);
    }, [dmFromStore]);

    function handleTalkChange(e: React.ChangeEvent<HTMLInputElement>) {
        setChanged(true);
        dispatch(changePxTalkActions.talkChange(pxTalk.company.id, e.target.value));
    }

    function handleDmBlur() {
        if (numericUtils.isNumber(dmValue) && dmValue !== dmFromStore) {
            dispatch(changePxTalkActions.evalDmChange(pxTalk.company.id, +dmValue));
        }
    }

    function handleTalkBlur() {
        if (changed) {
            setChanged(false);
            dispatch(changePxTalkActions.normalizeTalk(pxTalk.company.id, pxTalk.talk, pxTalk.levelType));
        }
    }

    return (
        <div className="flex-row flex-row-pxTalks">
            <div className="flex-none table-pxTalks-cell-company">{pxTalk.company.name}</div>
            <div className="flex-none table-pxTalks-cell-pxTalk">
                <input
                    className={cn('form-control', { 'is-invalid': !!pxTalk.error })}
                    type="text"
                    value={pxTalk.talk || ''}
                    autoComplete="off"
                    onChange={handleTalkChange}
                    onBlur={handleTalkBlur}
                />
                {!!pxTalk.error && <div className="form-error">{pxTalk.error}</div>}
            </div>
            <div className="flex-none table-pxTalks-cell-normalized text-right">
                {pxTalk.normalizedLevel || ''}
            </div>
            <div className="flex-none table-pxTalks-cell-type">
                <ButtonSwitch
                    sourceItems={[pxTalkLevelTypes.price, pxTalkLevelTypes.DM]}
                    selectedValue={pxTalk.levelType}
                    onSelectionChange={(levelType: LevelType) =>
                        dispatch(changePxTalkActions.levelTypeChange(pxTalk.company.id, levelType))
                    }
                    className="control-group-type01"
                />
            </div>
            <div className="flex-none table-pxTalks-cell-eval-dm">
                <MaskedInput
                    className="form-control"
                    mask={dmMask}
                    disabled={isRequestingEvalDm}
                    value={dmValue}
                    onChange={e => setDmValue(e.target.value)}
                    onBlur={handleDmBlur}
                />
            </div>
            <i
                className="btn-link btn-danger icon icon-delete"
                onClick={() => dispatch(changePxTalkActions.deletePxTalk(pxTalk.company.id))}
            ></i>
        </div>
    );
}
